<!--  -->
<template>
  <div class="wrapper" ref="wrapper">
    <div class="header-wrapper">
      <div class="header">停车管理</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="onSearch">搜索</Button>
        <Button class="bkcc-btn" @click="searchReset">重置</Button>
        <Button class="bkcc-btn" @click="exportTable">导出</Button>
        <Button class="bkcc-btn" @click="openSetting">信息采集</Button>
      </div>
    </div>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="5">
              <form-item label="姓名" prop="title">
                <i-input v-model="query.createuser" clearable placeholder="请输入姓名"/>
              </form-item>
            </i-col>
            <i-col span="5">
              <form-item label="车牌号" prop="title">
                <i-input v-model="query.carnumber" clearable placeholder="请输入车牌号"/>
              </form-item>
            </i-col>
            <i-col span="5">
              <form-item label="采集条件" prop="reportfromname">
                <i-select v-model="query.reportfromname" clearable placeholder="请选择采集条件">
                  <i-option
                    :value="item.name"
                    v-for="item in condition"
                    :key="item.id"
                  >{{item.name}}</i-option>
                </i-select>
              </form-item>
            </i-col>
            <i-col span="5">
              <form-item label="是否有车" prop="hascar">
                <i-select v-model="query.hascar" clearable placeholder="请选择">
                  <i-option
                    :value="item.name"
                    v-for="item in hascarlist"
                    :key="item.id"
                  >{{item.name}}</i-option>
                </i-select>
              </form-item>
            </i-col>
            <i-col span="5" v-if="isJiedao == 1">
              <form-item label="行政区域" prop="reportCompany">
                <i-select v-model="query.reportCompany" clearable placeholder="请选择行政区域" @on-change="areaChange">
                  <i-option
                    :value="item.name"
                    v-for="item in reportCompany"
                    :key="item.value"
                  >{{item.name}}</i-option>
                </i-select>
              </form-item>
            </i-col>

          </row>
        </i-form>
      </div>
      <div class="table-tabs">

        <div class="table-data">
          <i-table
            :columns="tableHeader"
            :border="true"
            :loading="isTableLoading"
            :data="tableData"
            stripe
            ref="table"
            @on-row-dblclick="handleClickDetail"
          />
          <div class="page">
            <page :total="total" @on-change="pageChange" show-total/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        isJiedao:0,
        page:1,
        isTableLoading:false,
        query: {
          createuser: "",
          carnumber: "",
          condition: [],
          reportCompany:'',
          hascar:''
        },
        condition:[],
        hascarlist:[{
          id:1,
          name:'是'
        },{
          id:0,
          name:'否'
        }],
        reportCompany:[],
        tableHeader: [
          {
            title: "姓名",
            key: "realName",
          },
          {
            title: "车牌号",
            key: "carNo"
          },
          {
            title: "手机号",
            key: "phoneNO"
          },
          {
            title: "身份证号",
            key: "idCardNo",
          },
          {
            title: "家庭住址",
            key: "address",
          },
          {
            title: "采集条件",
            key: "optionTitle",
          },{
            title: "用户填写",
            key: "userWrite"
          },{
            title: "上报时间",
            key: "createTime"
          },{
            title: "操作",
            key: "op",
            width:80,
            render: (h, params) => {
              return h('div', [
                h('div', {
                  style: {
                    marginRight: '5px',
                    color:'#5e6d94',
                  },
                  on: {
                    click: () => {
                      this.deleteItem(params.index)
                    }
                  }
                }, '[删除]'),
              ]);
            }
          }],
        tableData:[],
        total:0
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      openSetting(){
        this.$router.push({ name: "carManageSetting"});
      },
      areaChange(e){
        let communityId = this.reportCompany.filter(item=>item.name == e)[0].communityId;
        this.getParkingOptionList(communityId)
      },
      onSearch(page){
        //搜索
        let data = {}
        let query = this.query
        if(query.createuser) data.realName = query.createuser;
        if(query.carnumber) data.carNO = query.carnumber;
        if(query.reportfromname) data.optionId = this.condition.filter(item=>item.name == query.reportfromname)[0].id;
        if(query.hascar) data.hasCar = this.hascarlist.filter(item=>item.name == query.hascar)[0].id;
        if(query.reportCompany) data.communityId = this.reportCompany.filter(item=>item.name == query.reportCompany)[0].communityId;
        this.page = typeof(page) == 'number'?page:1

        this.getList(data)
      },
      searchReset(){
        //重置搜索条件
        this.query = {
          createuser:'',
          carnumber:'',
          reportfromname:'',
          hascar:'',
          reportCompany:''
        }
        this.page = 1
        this.getList()
      },
      exportTable(){
        //导出
        let url = this.urlobj.exportData + '?'
        url += '&realName=' +this.query.createuser
        url += '&carNO=' +this.query.carnumber

        let data =this.condition.filter(item=>item.name == this.query.reportfromname)
        url += '&optionId=' +(data.length>0?data[0].id:'');

        let data2 = this.hascarlist.filter(item=>item.name == this.query.hascar)
        url += '&hasCar=' +(data2.length>0?data2[0].id:'');

        let communityId = this.$store.state.streetorcommunityid
        if(this.query.reportCompany) communityId = this.reportCompany.filter(item=>item.name == this.query.reportCompany)[0].communityId;
        url += '&communityId=' +communityId;

        window.open(url)
      },
      handleClickDetail(){
        //查看详情
      },
      pageChange(val){
        //翻页
        //this.page = val;
        this.onSearch(parseInt(val))
      },
      getList(params){
        console.log('getList')
        //获取停车信息列表
        let url = this.urlobj.getParklingList;
        let data = {
          pageNum: this.page,
          pageSize: 10,
          ...params
        };
        console.log(this.$store.state.streetorcommunityid)
        this.isTableLoading = true;
        this.$post(url, data).then(res => {
          this.isTableLoading = false;
          if (res.isSucceed) {
            this.total = parseInt(res.total);
            let list = res.rows.map(item => {
              return {
                id: item.id,
                realName: item.realName,
                idCardNo: item.idCardNO,
                carNo: item.hasCar==1?(item.carNO?item.carNO:'有车，暂未关联'):'无车',
                phoneNO: item.phoneNO,
                address: item.address,
                optionTitle:item.optionTitle,
                userWrite:item.userWrite,
                createTime: item.createTime?item.createTime.split('.')[0]:'',
              };
            });
            this.tableData = list
            console.log(this.tableData)
          }
        }).catch(e=>{
          this.isTableLoading = false;

        })
      },
      getParkingOptionList(communityId){
        let url = this.urlobj.getParkingOptionList;
        this.$post(url, {
          communityId
        }).then(res => {
          if(res.rows.length){
            let data = res.rows.map((item,index)=>{
              return{
                id:item.id,
                name : item.title,
              }

            })
            this.condition = data

          }
        }).catch(e=>{

        })
      },
      deleteItem(index){
        if(!this.tableData[index].id){
          this.$Message.info('不可删除用户反馈信息')
          return
        }
        let url = this.urlobj.deleteParkingInfo(this.tableData[index].id)
        this.$delete(url, {}).then(res => {
          if(res.isSucceed){
            this.$Message.success("删除成功");
            this.onSearch(this.page)
          }
        }).catch(e=>{

        })
      },
      getShequ() {
        this.$get(this.urlobj.getOrgAll).then(res => {
          let clist = [];
          clist = res.rows.map(item => {
            if(item.communityId == this.$store.state.streetorcommunityid)  this.query.reportCompany = item.communityName
            return {
              name: item.communityName,
              communityId: item.communityId
            };
          });
          console.log(clist);
          this.reportCompany = clist;
        });
        this.getList({communityId:this.$store.state.streetorcommunityid})
      },

    },

    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.isJiedao = this.$store.state.isJiedao;
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getParkingOptionList(this.$store.state.streetorcommunityid)
      if(this.$store.state.isJiedao){
        this.getShequ()
      }else{
        this.getList()
      }
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  .wrapper {
    color: #666666;
    overflow: hidden;
    height: 100%;
  }

  .wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    /* height: 4px; */
  }
  .header-wrapper {
    display: flex;
    justify-content: center;
    height: 84px;
    line-height: 84px;
    position: relative;
  }
  .header {
    font-size: 25px;
    text-align: center;
  }
  .addManager {
    position: absolute;
    right: 20px;
  }

  .content {
    //   @content();
    max-width: 96%;
    margin: 20px;
    margin-left: 40px;
    overflow: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
  }
  .table-tabs {
    max-width: 100%;
    padding: 0;
    margin-top: 30px;

    /deep/ .ivu-tabs-bar {
      margin-bottom: 0;
      border-bottom: 0;
    }
    /deep/ .ivu-tabs-tab-active {
      color: white;
      background: #fe7d43;
      border-radius: 5px 5px 0 0;
    }
    /deep/ .ivu-tabs-ink-bar {
      height: 0px;
    }
    /deep/ .ivu-tabs-nav {
      padding-left: 10px;
      color: black;
    }
    /deep/ .ivu-table-tip {
      overflow-x: hidden
    }
  }
  .table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);
    .page {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
    }
  }
</style>
